import React from "react";
import "@/App.css";
import { AnimatePresence } from "framer-motion";
import { StyleProvider, useHOH, STEP } from "./context/StyleContext";
import { Toaster } from "./components/ui/sonner";
import GridBackground from "./components/GridBackground";
import TopBar from "./components/hoh/TopBar";
import IntroScreen from "./components/hoh/steps/IntroScreen";
import OccasionStep from "./components/hoh/steps/OccasionStep";
import PhotoUploadStep from "./components/hoh/steps/PhotoUploadStep";
import HairstylePreviewStep from "./components/hoh/steps/HairstylePreviewStep";
import OutfitOptionsStep from "./components/hoh/steps/OutfitOptionsStep";
import AccessoryProductsStep from "./components/hoh/steps/AccessoryProductsStep";
import FinalLookStep from "./components/hoh/steps/FinalLookStep";
import BookingStep from "./components/hoh/steps/BookingStep";
import ContentStudioStep from "./components/hoh/steps/ContentStudioStep";
import TrendingFeedStep from "./components/hoh/steps/TrendingFeedStep";

const STEPS = {
  [STEP.INTRO]: IntroScreen,
  [STEP.OCCASION]: OccasionStep,
  [STEP.UPLOAD]: PhotoUploadStep,
  [STEP.HAIR]: HairstylePreviewStep,
  [STEP.OUTFIT]: OutfitOptionsStep,
  [STEP.ACCESSORIES]: AccessoryProductsStep,
  [STEP.FINAL]: FinalLookStep,
  [STEP.BOOK]: BookingStep,
  [STEP.CONTENT]: ContentStudioStep,
  [STEP.TRENDING]: TrendingFeedStep,
};

function Journey() {
  const { step } = useHOH();
  const Current = STEPS[step] || IntroScreen;
  return (
    <GridBackground>
      <TopBar />
      <main className="pt-16">
        <AnimatePresence mode="wait">
          <div key={step}>
            <Current />
          </div>
        </AnimatePresence>
      </main>
    </GridBackground>
  );
}

function App() {
  return (
    <StyleProvider>
      <Journey />
      <Toaster position="top-center" richColors />
    </StyleProvider>
  );
}

export default App;
